import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { Monitoring } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/monitoring")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <Monitoring />
    </RouteGuard>
  ),
});
